import { ReachFeature } from '@reach/shared-types/features';
import type { AutomationTemplate } from './automations-tab/templates.types';
import type { FeatureSurfaceName } from './FeatureSurfaceContext';

export interface FeatureSurfaceConfig {
  /** Engage owns blank template creation; reputation templates only arrive from the defaults. */
  canCreateBlankTemplate: boolean;
  /** The "Start from a template" row of engage default templates. */
  showsEngageDefaultTemplates: boolean;
  /** The menu that seeds the reputation default automations. */
  showsReputationDefaultsMenu: boolean;
  /** The sub-type column, which only reputation templates populate. */
  showsSubTypeColumn: boolean;
}

export const FEATURE_SURFACE_CONFIG: Record<FeatureSurfaceName, FeatureSurfaceConfig> = {
  engage: {
    canCreateBlankTemplate: true,
    showsEngageDefaultTemplates: true,
    showsReputationDefaultsMenu: false,
    showsSubTypeColumn: false,
  },
  reputation: {
    canCreateBlankTemplate: false,
    showsEngageDefaultTemplates: false,
    showsReputationDefaultsMenu: true,
    showsSubTypeColumn: true,
  },
};

/**
 * Engage is an allowlist rather than a "not reputation" denylist, so a template tagged with a
 * future feature (voice, acquire) drops out of Engage on its own instead of leaking into it.
 * Untagged templates predate feature tagging and belong to Engage.
 */
export function templateMatchesFeature(
  template: Pick<AutomationTemplate, 'feature'>,
  feature: FeatureSurfaceName,
): boolean {
  if (feature === 'reputation') {
    return template.feature === ReachFeature.REPUTATION;
  }
  const isUntagged = template.feature === null || template.feature === undefined;
  return isUntagged || template.feature === ReachFeature.ENGAGE;
}
